type CloneFn = (row: any, parent: any) => any | null
export function toArray(list: any[] = [], cloneFn: CloneFn, childrenKey = 'children') {
  const ret: any[] = []
  traverse(list, null)
  return ret

  function traverse(rows: any[], parent: any = null) {
    if (!rows) return
    rows.forEach(v => {
      const children = v[childrenKey] || []
      const row = cloneFn ? cloneFn(v, parent) : clone(v)
      ret.push(row)
      traverse(children, row)
    })
  }

  function clone(row: any) {
    delete row[childrenKey]
    return Object.assign({}, row)
  }
}

export function equalObj(val1: any, val2: any, template: any) {
  let flag = true
  for (let i = 0, len = val1.length; i < len; i++) {
    const obj = val1[i]
    const obj2 = val2[i]
    template.forEach((element: any) => {
      if (!obj[element] && !obj2[element]) {
        return true
      }
      console.log(Number(obj[element]))
      console.log(Number(obj2[element]))
      if (Number(obj[element]) !== Number(obj2[element])) {
        flag = false
      }
    })
  }
  return flag
}

export function NumberCheck(num: any) {
  let str = num
  str = str.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
  str = str.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
  str = str.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  str = str.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入两个小数
  if (str.indexOf('.') < 0 && str !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    str = parseFloat(str)
  }
  return str
}
